const reducer = (state, action) => {
    switch (action.type) {
        case 'update':
            return { ...state, ...action.newState };
        case 'doingAjax':
            return { ...state, isDoingAjax: true };
        case 'ajaxDone':
            return { ...state, isDoingAjax: false };
        default:
            return state;
    }
};

export default reducer;
